var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"main"},[_c('AppNavigation'),_c('v-layout',[_vm._t("default")],2),_c('div',{staticClass:"mb-6"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }